import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CircularProgress } from "@mui/material";
import Modal from "@mui/material/Modal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import ReactPlayer from "react-player";
import VoteComponent from "./ModalVoteComponent";
import moment from "moment";
import CommentBox from "../common/ComentBox";
import { useSelector } from "react-redux";
import { getGoal } from "../../../api/getGoal";
import { toast } from "react-toastify";
import ShareComponent from "../common/share/Index";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90dvw",
  height: "90dvh",
  bgcolor: "#242743",
  border: "1px solid #414466",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",

  //   p: 4,
};

const headStype = {
  padding: "15px 15px",
  borderBottom: "1px solid #414466",
  display: "flex",
  alignItems: "center",
};

const contentStyle = {
  padding: "15px 15px",
  flexGrow: "1",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
};

export default function GoalModal({ open, setOpen, data, setData }) {
  const [voteState, setVoteState] = useState(data.voteCount);
  const [loading, setloading] = useState(true);
  const token = useSelector((state) => state.auth.token);
  const [goal, setGoal] = useState(null);
  const loggedUser = useSelector((state) => state.loggedUser.user);

  const fetchGoal = async (id, token) => {
    try {
      const data = await getGoal(id, token);
      // "";
      if (data.success) {
        setGoal(data.data[0]);
      } else {
        throw Error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchGoal(data.id, token);
    }
  }, [open]);
  const shareUrl = useRef(window.location.href);

  // "";

  return (
    <Modal
      open={open}
      onClose={() => {
        setData((tourData) => {
          const newGoals = tourData.map((goalData) =>
            goalData.id == data.id
              ? {
                  ...goalData,
                  voteCount: voteState,
                  isVoted: goalData.voteCount == voteState ? data.isVoted : 1,
                }
              : goalData,
          );
          const rankedGoals = newGoals
            .sort((a, b) => (a.voteCount > b.voteCount ? -1 : 1))
            .map((data, i) => ({ ...data, rank: i + 1 }));
          return rankedGoals;
        });

        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={headStype}>
          <IconButton
            onClick={() => {
              setData((tourData) => {
                const newGoals = tourData.map((goalData) =>
                  goalData.id == data.id
                    ? {
                        ...goalData,
                        voteCount: voteState,
                        isVoted:
                          goalData.voteCount == voteState ? data.isVoted : 1,
                      }
                    : goalData,
                );
                const rankedGoals = newGoals
                  .sort((a, b) => (a.voteCount > b.voteCount ? -1 : 1))
                  .map((data, i) => ({ ...data, rank: i + 1 }));
                return rankedGoals;
              });
              setOpen(false);
            }}
          >
            <ArrowBackIcon sx={{ color: "white" }} />
          </IconButton>

          <Box sx={{ flexGrow: "1", textAlign: "center" }}>
            <Typography
              component={"span"}
              sx={{
                fontSize: { sm: "22px", lg: "22px", xs: "16px" },
                color: "white",
                fontWeight: "bold",
              }}
            >
              {data?.title}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ borderBottom: "1px solid #414466" }}></Box>
        <Box sx={contentStyle}>
          <Box
            sx={{
              width: "100%",
              height: "70%",
              //   flexGrow: "1",
              maxWidth: "700px",
              maxHeight: "320px",
              alignSelf: "center",
            }}
          >
            <ReactPlayer
              url={data.video_link}
              controls={true}
              width="100%"
              height="100%"
              config={{
                file: {
                  attributes: {
                    poster: data.thumbnail,
                  },
                },
              }}
            />
          </Box>

          <Box sx={{ marginTop: "20px", flexGrow: "1" }}>
            <Box
              sx={{
                display: "flex",
                gap: { xs: "10px", md: "20px" },
                alignItems: "center",
              }}
            >
              <VoteComponent
                id={data.id}
                vote={data.isVoted}
                count={voteState}
                setCount={setVoteState}
                // setTournamentData={setTournamentData}
              />

              {!loggedUser.device_id ? (
                loading ? (
                  <CircularProgress enableTrackSlot size="25px" />
                ) : (
                  <CommentBox count={data.goalComments} id={data.id} />
                )
              ) : null}
              {/* 
              // {loading ? (
              //   <CircularProgress enableTrackSlot size="25px" />
              // ) : (
              //   <CommentBox count={data.goalComments} id={data.id} />
              // )} */}

              <ShareComponent
                data={data}
                title={data?.title}
                shareUrl={`${shareUrl.current}?share=${data.id}`}
              />
            </Box>

            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>Video Category: </strong>
              {data?.gCategory}
            </Typography>
            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>Video From (UK/International): </strong>
              {data?.from_uk ? "England" : "International"}
            </Typography>
            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>Created By: </strong>
              {data?.goalUserDetails?.firstName +
                " " +
                data?.goalUserDetails?.lastName}
            </Typography>
            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>City/Town: </strong>
              {data?.region}
            </Typography>

            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>club: </strong>
              {data?.club}
            </Typography>
            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>goal scorer: </strong>
              {data?.goal_scorer}
            </Typography>
            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>Created On: </strong>
              {moment(data?.createdAt).format("MM/DD/YYYY")}
            </Typography>
          </Box>
        </Box>

        <Box sx={{padding:"7.5px"}}>
          {/* footer */}
        </Box>
      </Box>
      {/* )} */}
    </Modal>
  );
}
